import React, { useEffect, useRef, useState } from "react"
import _isEmpty from "lodash/isEmpty"

import {
  addShareBtnAnalytics,
  getEventInfo,
} from "@/components/ProductDetail/v3/analytics"
import { appendPresetToUrl, getShortenedUrl } from "@/utils/helper"
import { getBreadcrumbEventInfo } from "@/components/ProductDetail/v3/analytics"
import ProductSocialShare from "@/components/Shared/ProductSocialShare/v1/ProductSocialShare"

const ProductBreadcrumb = ({
  staticTexts: {
    ariaLabel: { breadcrumb = "", page = "", print = "", share = "" } = {},
    home = "",
    serviceParts = "",
    priceFootnoteTitle = "",
    priceFootnote = "",
    colorFootnoteTitle = "",
    colorFootnote = "",
  },
  productCategory = "",
  name = "",
  homePagePath = "",
  plpServletPath = [],
  config = {},
  productAnalyticsData = "",
  productData = {},
  swatchUrl = "",
  imagesData = [],
  width = 0,
  presetConfigObject = {},
  isBundleProduct = "",
}) => {
  const [url, setUrl] = useState("")
  const [plpPagePath, setPlpPagePath] = useState("")
  const [serviceLandingPath, setServiceLandingPath] = useState("")
  const [showSocialLink, setShowSocialLink] = useState(false)
  const shareBtn = useRef(null)
  const [localCategory, setLocalCategory] = useState(
    productCategory || productData?.ProductLocalCategory_s
  )
  useEffect(() => {
    if (!_isEmpty(config)) {
      const { general = {} } = config
      getShortenedUrl(general.plpPagePath ?? "/").then(res =>
        setPlpPagePath(res)
      )
      getShortenedUrl(general.servicePartsLandingPath ?? "/").then(res =>
        setServiceLandingPath(res)
      )
    }
  }, [config, plpServletPath])
  useEffect(() => {
    setLocalCategory(productCategory || productData?.ProductLocalCategory_s)
  }, [productData, productCategory])
  useEffect(() => {
    if (
      plpServletPath &&
      productCategory &&
      (plpPagePath || serviceLandingPath)
    ) {
      const path = plpServletPath?.find(i =>
        i.categories.includes(productCategory)
      )

      let plpUrl
      if (productCategory) {
        if (path) {
          plpUrl = `${path.url}.html`
        } else if (productCategory === "Service Parts") {
          plpUrl = `${serviceLandingPath}.html`
        } else {
          plpUrl = `${plpPagePath}/${productCategory
            .replace(/ +/g, "-")
            .toLowerCase()}.html`
        }
      } else {
        plpUrl = `${serviceLandingPath}.html`
      }

      getShortenedUrl(plpUrl).then(url => setUrl(url))
    }
  }, [plpPagePath, serviceLandingPath, productCategory])

  // Hide social share options when user clicks outide the options
  useEffect(() => {
    window.addEventListener("click", handleClickOutside)
    return () => window.removeEventListener("click", handleClickOutside)
  }, [])

  const handleClickOutside = e => {
    const { target } = e
    if (!shareBtn.current.contains(target)) {
      setShowSocialLink(false)
    }
  }

  const handleShareClick = () => {
    setShowSocialLink(prevProp => !prevProp)
    addShareBtnAnalytics(productAnalyticsData?.stringProductInfo)
  }
  const addAnalytics = (internalLinkName = "", link = "") => {
    const page = window.pageObj || {}
    const eventInfo = getBreadcrumbEventInfo(internalLinkName, link)
    window.adobeDataLayer.push({
      event: "cmp:click",
      page,
      eventInfo,
    })
  }

  const printPDP = () => {
    const printNoteLen = document.getElementsByClassName(
      "product-detail-page__print-note"
    ).length
    if (printNoteLen === 0) {
      const printNote = `<div class='product-detail-page__print-note'><div class='container'><div class='row'><div class='col-12'><h6>${priceFootnoteTitle}</h6><p>${priceFootnote}</p><h6>${colorFootnoteTitle}</h6> <p>${colorFootnote}</p></div></div></div></div>`
      const printNoteDiv = document.createElement("div")
      printNoteDiv.innerHTML = printNote
      document.body.appendChild(printNoteDiv)
    }
    setTimeout(() => {
      window.print()
    }, 900)
  }
  if (productData) {
    return (
      <div className="header-section kf-react-plp-container">
        <div className="product-detail-page__breadcrumb">
          <nav aria-label={breadcrumb}>
            <ol role="list" data-testid="bcm-list">
              <li role="listitem">
                <a
                  aria-label={`${home} ${page}`}
                  className="product-detail-page__breadcrumb-link"
                  onClick={() => addAnalytics(home, homePagePath)}
                  href={homePagePath}
                >
                  {` ${home}`}
                </a>
                {" / "}
              </li>
              <li role="listitem">
                <a
                  aria-label={
                    productCategory
                      ? `${productCategory} ${page}`
                      : `${serviceParts} ${page}`
                  }
                  className="product-detail-page__breadcrumb-link"
                  onClick={() =>
                    addAnalytics(`${home} > ${productCategory}`, url)
                  }
                  href={url}
                >
                  {localCategory ? localCategory : serviceParts}
                </a>
              </li>
              <li role="listitem" className="adaopacity">
                {" / "}
                <a
                  aria-label={
                    productCategory
                      ? `${name} ${page}`
                      : `${serviceParts} ${page}`
                  }
                  aria-current={page}
                  className="product-detail-page__breadcrumb-link"
                  onClick={() =>
                    addAnalytics(`${home} > ${productCategory} > ${name}`, "#")
                  }
                  href="#"
                >
                  {productCategory ? name : serviceParts}
                </a>
              </li>
            </ol>
          </nav>
        </div>
        <div className="product-detail-page__print-share-container">
          <div role="list" className="print-and-share">
            <span role="listitem">
              <button
                tabIndex="0"
                className="gbh-data-layer"
                data-gbh-data-layer={getEventInfo("print")}
                data-gbh-data-layer-custom={
                  productAnalyticsData?.stringProductInfo
                }
                aria-label={print}
                onClick={() => printPDP()}
              >
                {" "}
                <img
                  src="/icons/print.svg"
                  alt=""
                  role="presentation"
                  width="17"
                  height="17"
                />
              </button>
            </span>
            <span role="listitem">
              <button
                tabIndex="0"
                aria-label={share}
                className="share-button"
                ref={shareBtn}
                onClick={handleShareClick}
                role="button"
                aria-haspopup
                aria-expanded={showSocialLink}
                aria-controls="print-and-share"
              >
                <img
                  src="/icons/share.svg"
                  alt=""
                  role="presentation"
                  width="17"
                  height="17"
                />
              </button>
            </span>
          </div>
          <ProductSocialShare
            disableInstagram
            showModal={showSocialLink}
            shareBtn={shareBtn}
            id="print-and-share"
            onClose={() => shareBtn?.current.focus()}
            asset={{
              description: productData?.ProductDescriptionProductShort_s ?? "",
              url: appendPresetToUrl(
                swatchUrl,
                imagesData[0]?.assetId,
                width,
                presetConfigObject,
                true
              ),
            }}
            analyticData={{
              eventAction: "pdp:product details:share",
              eventName: "pdp:product details:share",
              internalLinkPosition: `pdp${isBundleProduct ? ":bundle" : ""}`,
              internalLinkType: "pdp:share",
              internalLinkZoneName: "pdp:product details",
              custom: productAnalyticsData.stringProductInfo,
            }}
            isBundleProduct={isBundleProduct}
          />
        </div>
      </div>
    )
  }
}

export default ProductBreadcrumb
